<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #subCategoryForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="subCategory.id">{{ l('EditSubCategory') }}</span>

                        <span *ngIf="!subCategory.id">{{ l('CreateNewSubCategory') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="my-3">
                        <label class="form-label" for="SubCategory_Code">{{ l('Code') }} *</label>
                        <input
                            type="text"
                            #SubCategory_Code="ngModel"
                            id="SubCategory_Code"
                            class="form-control"
                            [(ngModel)]="subCategory.code"
                            name="Code"
                            minlength="0"
                            maxlength="50"
                            required
                        />
                        <validation-messages [formCtrl]="SubCategory_Code"></validation-messages>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="SubCategory_Name">{{ l('Name') }} *</label>
                        <input
                            type="text"
                            #SubCategory_Name="ngModel"
                            id="SubCategory_Name"
                            class="form-control"
                            [(ngModel)]="subCategory.name"
                            name="Name"
                            minlength="0"
                            maxlength="500"
                            required
                        />
                        <validation-messages [formCtrl]="SubCategory_Name"></validation-messages>
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-danger" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!subCategoryForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
